module.exports = __webpack_public_path__ + "img/emptyState.ab3ee929.png";